export const RecursiveRequestFunctions = {
    BySportId: "loadDataBySportId",
    ByRegionId: "loadDataByRegionIdAndPagination"
};
//# sourceMappingURL=RecursiveRequestFunctions.js.map